module.exports = __webpack_public_path__ + "assets/img/sai_rmi_hero.54cc0960.jpg";